<template>
  <div class="jd-goods-detail">
    <div class="download-btn-con">
      <download-btn />
    </div>

    <div class="sharing-rewards" v-if="currentPrice && currentPrice.goodsShareEarnAmount" @click="goAppDownload"><span class="num">￥{{ currentPrice.goodsShareEarnAmount }}</span></div>

    <div ref="detailCon" class="detail-con">
      <div class="header">
        <goods-detail-swipe></goods-detail-swipe>
        <img class="img" v-if="!skusImgs[currentSku]" :src="'http://img13.360buyimg.com/n12/' + detail.noneBookVO.imagePath" alt="">
      </div>

      <div class="goods-detail-msg">
        <div class="list-title">{{ detail.noneBookVO.name }}</div>
        <div class="price">
          <div class="left">
            <span class="flex-item red" v-if="currentPrice.sellPrice!==''">{{ currentPrice.sellPrice===0?'免费':('￥'+(currentPrice.sellPrice||'')) }}</span>
            <span class="flex-item red" v-if="currentPrice.sellPrice===''">暂无定价</span>
            <s class="flex-item original-price" v-if="currentPrice.displayOriginalPrice">原价：{{ currentPrice.displayOriginalPrice }}</s>
            <!--<span class="flex-item member-price" >会员价：{{ currentPrice }}</span>-->
          </div>
          <div class="right">
            <span class="num">热销: {{ detail.salesVolume || 0 }}</span>
            <span class="num">收藏: {{ detail.collectUserCount || 0 }}</span>
          </div>
        </div>
      </div>

      <div class="feedback-btn-con">商品有疑问？请反馈给客服人员<span class="check" @click="showFeedback=true">反馈</span></div>

      <div class="bg-10px"></div>

      <div class="agentSell" v-if="(shopDetail.userId!==userOpenId) && currentPrice.agentSellEnabled && (detail.shopId==$route.query.shopId)">
        <div class="left">我要分销</div>
        <div class="left-sub" @click="openAgentSell"><span class="red" @click="showAgentSell=true">返佣规则</span></div>
        <div class="text-con" @click="goAppDownload">返佣 <span class="red"> ￥{{ currentPrice['goodsAgentEarnAmountL'+userMemberLevel] }}</span> </div>
        <div class="icon-con" @click="goAppDownload">
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>

      <div class="bg-10px"></div>

      <shop-item />

      <div class="bg-10px"></div>

      <div class="deduct-from" v-if="deductNum>0">
        <div class="left">抵扣</div>
        <div class="center">
          <span class="icon" :class="deductIcon">{{ deductNum }} 枚</span>
        </div>
      </div>

      <div class="bg-10px"></div>

      <div class="select-cell">
        <div class="cell-item">
          <div class="title">已选</div>
          <div class="right">
            <div class="text-con" @click="openSku(99)"><span class="text">{{ currentsSelectText }}</span></div>
            <div class="icon"></div>
          </div>
        </div>
        <div class="cell-item">
          <div class="title">送至</div>
          <div class="right">
            <div class="text-con" @click="openArea"><span class="addr-text">{{ lastAddress.fullArea }}</span></div>
            <div class="icon"></div>
          </div>
        </div>
        <div class="cell-item">
          <div class="title">运费</div>
          <div class="right">
            <div class="text-con">
              <span class="text" v-if="currentsFreight===0">{{ currentPrice.sellPrice> 99 ? '免运费' : currentPrice.sellPrice>49 ? '6.00元' : '8.00元' }}</span>
              <span class="text" v-if="currentsFreight>0">{{ currentsFreight.toFixed(2) }} 元</span>
            </div>
          </div>
        </div>
      </div>

      <div class="evaluation-con" >
        <div class="bg-10px"></div>
        <div class="evaluation-header">
          <div class="title">评价</div>
          <div class="right" @click="sgGoodsEvaluationList">
            <div class="text-con"><span class="addr-text">更多评价</span></div>
            <div class="icon"></div>
          </div>
        </div>
        <div class="evaluation-list">
          <evaluation-item v-for="(item, i) in evaluation" :key="i" :item="item"></evaluation-item>
        </div>
      </div>

      <div class="bg-10px"></div>
      <!--课程详情-->
      <div class="detail-info">
        <div class="detail-info-title">商品详情</div>
        <div class="detail-info-cssContent" v-html="cssContent"></div>
        <div ref="detailInfoHtmlCon" class="detail-info-html">
          <div ref="detailHtmlCon" id="detailHtmlCon" class="detail-info-html-con" v-html="detailHtml"></div>
        </div>
        <div class="detail-info-jsContent" v-html="jsContent"></div>
        <div class="detail-info-param" v-html="param"></div>
      </div>

      <div class="bg-10px"></div>

      <div class="technical-support">云柑社区提供技术支持</div>
    </div>
    <div class="is-area-restrict" v-if="currentIsAreaRestrict">该商品在该地区暂时不支持销售，非常抱歉</div>
    <div class="detail-bottom-con">
      <div class="item-con">
        <div class="item clickable" @click="goMallShop">
          <img class="icon icon2" src="./img/enterShop.png" alt="">
          <span class="text">进店</span>
        </div>
        <div v-if="!detail.isCollected" class="item clickable" @click="changeCollect(true)">
          <img class="icon icon3" src="./img/collect.png" alt="">
          <span class="text">收藏</span>
        </div>
        <div v-if="detail.isCollected" class="item clickable" @click="changeCollect(false)">
          <img v-if="" class="icon icon3" src="./img/is-collect.png" alt="">
          <span class="text">已收藏</span>
        </div>
        <div class="item clickable" @click="goMy">
          <img class="icon icon4" src="./img/my.png" alt="">
          <span class="text">我的</span>
        </div>
      </div>
      <div class="buy-btn-con">
        <div class="btn-con" v-if="currentPrice.sellPrice && currentSkuStock!==34 && currentSkuStock!==36 && currentSalesCheck.saleState===1 && currentUpDownStatus===1 && !currentIsAreaRestrict">
          <div class="btn add-to-cart" @click="openSku(1)">加入购物车</div>
          <div class="btn buy-at-once" @click="openSku(2)">立即购买</div>
        </div>
        <div class="btn-con no-goods" v-else>
          <div class="btn add-to-cart">加入购物车</div>
          <div class="btn buy-at-once">无货</div>
        </div>
      </div>

    </div>

    <van-popup
        class="show-agent-sell"
        v-model="showAgentSell"
    >
      <div class="show-agent-sell-con">
        <div class="title">返佣规则</div>
        <div class="item item1" :class="{active: userMemberLevel==='1'}">
          <div class="left"></div>
          <div class="text">普通用户</div>
          <div class="right">￥{{ currentPrice.goodsAgentEarnAmountL1 }}</div>
        </div>
        <div class="item item2" :class="{active: userMemberLevel==='2'}">
          <div class="left"></div>
          <div class="text">银牌用户</div>
          <div class="right">￥{{ currentPrice.goodsAgentEarnAmountL2 }}</div>
        </div>
        <div class="item item3" :class="{active: userMemberLevel==='3'}">
          <div class="left"></div>
          <div class="text">金牌用户</div>
          <div class="right">￥{{ currentPrice.goodsAgentEarnAmountL3 }}</div>
        </div>
        <div class="close-icon" @click="showAgentSell=false"></div>
      </div>
    </van-popup>

    <buy-cart-icon class="buy-cart-icon" />
    <van-dialog
        v-model="showFeedback"
        show-cancel-button
        @confirm="confirmFeedback"
    >
      <div class="feedback-con">
        <div class="title">商品反馈</div>
        <div class="text-con">
          <van-field
              class="feedback-textarea"
              v-model="feedbackText"
              rows="5"
              autosize
              maxlength="200"
              show-word-limit
              type="textarea"
              placeholder="请输入反馈内容"
          />
        </div>
      </div>
    </van-dialog>

    <sg-area :show="showArea" :editArea="editArea" @onChange="onChange" @onClose="onClose" />

    <jd-sku></jd-sku>

    <wx-config v-on:wxConfigReady="wxConfigReady" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserByUserInfo } from '@/api/login'
import { getJdGoodsDetail, evaluatedList, goodsConsult } from '@/api/mall/mallGoods'
import { introduce } from '@/api/mall/mallShop'
import { memberPlatformGrade } from '@/api/member'
import shopItem from '@/views/Mall/sg/components/shopItem'
import evaluationItem from '@/views/Mall/sg/components/evaluationItem';
import jdSku from '@/views/Mall/sg/components/jdSku';
import goodsDetailSwipe from '@/views/Mall/sg/components/goodsDetailSwipe';
import sgArea from '@/components/sgArea'
import DownloadBtn from '@/components/downloadBtn'
import BuyCartIcon from '@/components/buyCartIcon'
import wxConfig from '@/components/weixin/wxConfig'
export default {
  components: {
    evaluationItem,
    shopItem,
    jdSku,
    goodsDetailSwipe,
    sgArea,
    BuyCartIcon,
    wxConfig,
    DownloadBtn,
  },
  data () {
    return {
      showArea: false,
      editArea: {},

      shopId: '', // 当url中没传shopId 时，使用该字段，字段值从商品详情中获取
      showFeedback: false,// 展示反馈
      feedbackText: '',// 反馈内容
      userOpenId: this.session('userOpenId'),
      detail: {
        noneBookVO: {}
      },
      detailHtml: '',//商品详情HTML
      cssContent: '',
      jsContent: '',

      param: '',//商品规格

      shopDetail: {},
      detailMobileHtml: '', // 详情 渲染 内容
      outerLinks: [], //商家推广外链
      // outInviteCode: '',// 商品被 分享用户分享，用openId 获取的邀请码
      origin: window.location.origin,

      evaluation: [],//商品评价列表
      userMemberLevel: 1,//当前用户会员等级
      showAgentSell: false,//展示分销奖励
    }
  },
  computed:{
    ...mapGetters([
      'currentSku',//当前sku
      'skusImgs',
      'currentsSelectText',//当前选中规格名称
      'goodsDetails',//所有sku的详情
      'skusStyle',//所有sku的详情样式
      // 'skusImgs',//所有sku的所有图片
      'currentPrice',//当前sku价格
      'currentSkuStock',//是否有库存
      'lastAddress',//配送区域
      'currentsFreight',//当前所选商品运费
      'currentSalesCheck',//当前商品是否可售校验
      'currentUpDownStatus',//当前商品上下架状态
      'currentIsAreaRestrict',//当前商品当前地区是否限制购买
      'Pcoin',//平台金币信息
    ]),
    // sharingRewardsNum(){
    //   let n = (this.shopDetail.goodsShareEarnRate||0) * (this.currentPrice.goodsShareEarnAmount||0);
    //   n = Number( (n+'').match(/^\d+(?:\.\d{0,2})?/) )
    //   return n
    // },
    deductNum(){//金币抵扣数
      let num = (this.currentPrice.integralDeductCashAmount||0) / (this.Pcoin.buyPrice||1)
      return Math.floor(num)
    },
    deductIcon(){
      return ('icon'+(this.deductNum+'').length)
    },
  },
  watch: {
    currentSku(sku){
      console.log('watch--->sku: ', sku)
      // window.setTimeout(()=>{
      //   this.detail = this.goodsDetails[sku]
      //   this.detailHtml = this.goodsDetails[sku].noneBookVO.introduction
      //   this.param = this.goodsDetails[sku].noneBookVO.param
      //   document.title = this.goodsDetails[sku].noneBookVO.name
      // },500)
    },
    goodsDetails(data){
      // console.log(data)
      this.detail = data[this.currentSku]
      this.detailHtml = this.replaceHttp(this.removeWidthAndHeight( data[this.currentSku].noneBookVO.introduction || ''))
        // console.log(this.detailHtml)
      this.param = data[this.currentSku].noneBookVO.param
      document.title = data[this.currentSku].noneBookVO.name
    },
    skusStyle(data){
      this.cssContent = data[this.currentSku].cssContent
      this.jsContent = data[this.currentSku].jsContent
    },
    Pcoin: {
      handler(newData, oldData) {
        if(!newData.buyPrice){
          this.$store.dispatch('app/getPlatformCoin', {})
        }
      },
      deep:true,
      immediate: true
    },
  },
  created(){
    window.scrollTo(0,0);
    this.$store.commit('sg/change_skuShow', false)
    this.getJdGoodsDetail()
    if(this.$route.query.shopId){//店铺详情
      this.shopId = this.$route.query.shopId
      this.getShopHome()
      this.getEvaluatedList()
    }
    this.getMemberRank()

    window.setTimeout(()=>{ //动态修改商品详情容器宽高
      this.$refs.detailCon.addEventListener('scroll',this.scroll)
    },300)
    // if(this.$route.query.inviteUserId){
    //   this.getUserByUserInfo(this.$route.query.inviteUserId)
    // }
  },
  mounted(){

  },
  methods: {
    // 替换双http
    replaceHttp(str){
      return str.replace(/http.{0,4}https?\:?\/\//g, "http://")
    },
    openSku(type){
      this.session('skuShowType', type)
      this.$store.commit('sg/change_skuShow', true)
    },
    openArea(){
      this.showArea = true
    },
    onChange(text){
      console.log(text)
    },
    onClose(data){
      this.showArea = false;
      let req = {
        userOpenId: this.session('userOpenId'),
        areaType: 'SYS',
        provinceAreaId: data.area1 ? data.area1.areaId : 0,
        cityAreaId: data.area2 ? data.area2.areaId : 0,
        countyAreaId: data.area3 ? data.area3.areaId : 0,
        townAreaId: data.area4 ? data.area4.areaId : 0
      };
      if(!req.countyAreaId && (req.provinceAreaId || req.cityAreaId) ){
        this.$toast('请选择完整区域！')
      }else {
        if( req.countyAreaId && (req.countyAreaId!==this.lastAddress.countyId) ){ //若地址发生改变，则调用接口
          this.$store.dispatch('sg/updateLatestAddress', req)
        }
      }

    },


    //获取店铺信息
    getShopHome() {
      introduce({shopId: this.$route.query.shopId || this.shopId}).then(res=>{
        this.shopDetail = res.data;
        this.$store.dispatch('mall/changeShopDetail', res.data)
      })
    },
    // 获取商品详情
    getJdGoodsDetail(){
      this.$store.commit('sg/change_shopId', this.$route.query.shopId)
      this.$store.dispatch('sg/initGoodsId', this.$route.query.goodsId).then(()=>{
        this.$store.dispatch('sg/getLatestAddress')//查询最后地址(调用1次)
        let req = {
          goodsId: this.$route.query.goodsId,
          shopId: this.$route.query.shopId
        }
        if(this.$route.query.inviteUserId){
          req.inviteUserId = this.$route.query.inviteUserId
        }
        getJdGoodsDetail(req).then(res=>{
          let sku = res.data.sku
          this.$store.dispatch('sg/change_currentSku', sku)//（初始化调用）

          this.$store.dispatch('sg/getJDSimilarSku', sku)//查询当前sku的同类商品(调用1次)
        })
      })
    },


    // 处理商品详情容器大小
    scroll(){
      let width = 0, height = 0;
      let screenWidth = window.screen.width; // 屏幕宽度
      let detailInfoHtmlCon = this.$refs.detailInfoHtmlCon; // 详情父容器
      let detailHtmlCon = this.$refs.detailHtmlCon; // 详情容器
      width = detailHtmlCon.scrollWidth // 缩放前的宽度
      let proportion = screenWidth/width // 缩放比例
      height = detailHtmlCon.scrollHeight //原本高度
      let setHeight =  height * proportion // 新高度
      detailHtmlCon.setAttribute('style', `transform-origin: 0px 0px;transform: scale(${proportion});`)
      detailInfoHtmlCon.setAttribute('style', `height: ${setHeight}px;`)
      // console.log('缩放比例: ' + proportion)
      // console.log('screenWidth: ' + screenWidth)
      // console.log('width: ' + width)
      // console.log('height: ' + height)
      // console.log('setHeight: ' + setHeight)
    },
    goAppDownload(){
      this.appDownload({inviteCode: this.session('user').inviteCode || '0608'})
    },


    // 删除 width、height 属性
    removeWidthAndHeight(str){
      let reg = /(width=\"([0-9]+)\")|(height=\"([0-9]+)\")/gi;
      // let arr=str.match(reg)
      let newStr=str.replace(reg,'data-my="a"');
      let newArr=newStr.split('data-my="a"');
      let html='';
      for(let i=0;i<newArr.length;i++){
        html+=newArr[i];
      }
      return html
    },

    // 跳转至店铺主页
    goMallShop(){
      // if(this.$route.query.shopId==20234){//跳转至京购
      //   this.$router.push({name: 'sgGoodsList' })
      // }else { //跳转至店铺
      //   let mallShopPageQuery = {shopId: this.$route.query.shopId };
      //   if(this.$route.query.inviteUserId){
      //     mallShopPageQuery.inviteUserId = this.$route.query.inviteUserId
      //   }
      //   this.$router.push({name: 'sgShopIndex', query: mallShopPageQuery })
      // }

      let mallShopPageQuery = {shopId: this.$route.query.shopId };
      if(this.$route.query.inviteUserId){
        mallShopPageQuery.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'sgShopIndex', query: mallShopPageQuery })


    },
    // 收藏、取消收藏
    changeCollect(isCollected){
      this.$store.dispatch('sg/changeGoodsCollect', {
        goodsId: this.$route.query.goodsId,
        isCollected: isCollected
      })
    },
    goMy(){
      this.$router.push({name: 'my'})
    },

    // 获取评论列表
    getEvaluatedList(){
      evaluatedList({goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId, page: 1, size: 2}).then(res=>{
        this.evaluation = res.data.items || []
      })
    },
    sgGoodsEvaluationList(){
      if(this.evaluation.length===0){
        this.$toast('没有更多评论了')
        return false
      }
      this.$router.push({name: 'sgGoodsEvaluationList', query: {shopId: this.$route.query.shopId, goodsId: this.$route.query.goodsId}})
    },

    // 反馈
    confirmFeedback(){
      console.log(this.feedbackText)
      if(this.feedbackText){
        goodsConsult({
          content: this.feedbackText,
          goodsId: this.detail.goodsId,
          productId: this.detail.productId,
        }).then(res=>{
          if(res.code===200){
            this.$toast('反馈成功！')
            this.feedbackText = ''
          }
        })
      }
    },

    //获取会员等级
    getMemberRank(){
      memberPlatformGrade({}).then(res => {
        if(res.code===200){
          this.userMemberLevel = res.data.memberLevel
        }
      })
    },

    // 展示返佣金额
    openAgentSell(){
      console.log(132465)
    },

    // 微信分享
    wxConfigReady(){
      console.log('wxConfigReady,设置微信分享')
      window.setTimeout(()=>{
        //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
        window.wx.updateAppMessageShareData({
          title: this.session('user').nickname + '给你分享了一个商品', // 分享标题
          desc: this.detail.noneBookVO.name, // 分享描述
          link: this.origin + '/jd/jdGoodsDetail?'
          + 'goodsId=' + this.$route.query.goodsId
          + '&shopId=' + this.$route.query.shopId
          + '&inviteUserId=' + this.session('userOpenId'),
          imgUrl: 'http://img13.360buyimg.com/n3/'+this.detail.noneBookVO.imagePath, // 分享图标
          success: function () {
            // 设置成功
            console.log('省购--商品详情 设置分享朋友成功！')
          }
        });
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
        window.wx.updateTimelineShareData({
          title: this.session('user').nickname + '给你分享了一个商品', // 分享标题
          link: this.origin + '/jd/jdGoodsDetail?'
          + 'goodsId=' + this.$route.query.goodsId
          + '&shopId=' + this.$route.query.shopId
          + '&inviteUserId=' + this.session('userOpenId'),
          imgUrl: 'http://img13.360buyimg.com/n3/'+this.detail.noneBookVO.imagePath, // 分享图标
          success: function () {
            // 设置成功
            console.log('省购--商品详情 设置分享朋友圈成功！')
          }
        })
      },300)
    },
  }
}
</script>

<style scoped lang="less">
@url: 'https://fileqn.anttalk.vip/';
@url2: '../../../assets/mall/';
.jd-goods-detail{
  position: relative;
  width: 100%;height: 100%;
  font-size: 14px;
  .download-btn-con{
    position: fixed;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 55px;
  }
  .sharing-rewards{
    position: absolute;z-index: 20;top: 67px;right: 12px;
    width: 47px;height: 48px;font-size: 10px;
    background: url("@{url2}sharing-rewards-icon.png") no-repeat 50% 50%;background-size: 100%;
    .num{
      display: flex;width: 100%;line-height: 1;padding-top: 22px;padding-right: 2px;
      color: #fff;justify-content: center;align-items: center;
    }
  }
  .detail-con{
    position: absolute;
    top: 55px;
    left: 0;
    right: 0;
    bottom: 50px;
    overflow-y: auto;
    z-index: 0;
    .header{
      width: 375px;
      height: 375px;
      position: relative;overflow: hidden;
      .img{
        display: block;
        width: 100%;
        height: 100%;
      }

    }
    .goods-detail-msg{
      padding: 12px;
      .list-title{
        margin-bottom: 6px;
        padding-bottom: 2px;
        font-size: 18px;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .price{
        display: flex;align-items: flex-end;
        line-height: 1;padding: 10px 0;
        .left{
          flex: 1;display: inline-flex;align-items: flex-end;
          .red{
            padding-right: 10px;
            font-size: 16px;
            color: #f74d4d;
          }
          .original-price{
            font-size: 10px;
            color: #999;
          }
          .member-price{
            font-size: 10px;
            color: #f74d4d;
            border-radius: 4px;
            border: 1px solid #f74d4d;
            padding: 4px 6px;
            margin-left: 12px;
            line-height: 1;
          }
        }
        .right{
          width: 120px;display: inline-flex;justify-content: flex-end;
          .num{
            font-size: 10px;color: #999;padding-right: 10px;
            &:last-child{padding-right: 0;}
          }
        }
      }
    }
    .feedback-btn-con{
      font-size: 10px;
      color: #999;
      line-height: 1;
      padding: 11px 12px;
      border-top: 1px solid #eee;
      .check{
        padding-left: 15px;
        color: #1585f3;
      }
    }

    .agentSell{
      display: flex;align-items: center;height: 44px;color: #070707;
      .left{
        width: 67px;height: 100%;
        display: inline-flex;justify-content: flex-end;align-items: center;
      }
      .left-sub{
        width: 50px;height: 100%;margin: 0 10px;
        display: inline-flex;justify-content: center;align-items: center;
        .red{
          border: 1px solid #f31515;color: #f31515;font-size: 9px;border-radius: 5px;
          width: 46px;height: 15px;
          display: inline-flex;display: inline-flex;justify-content: center;align-items: center;
        }
      }
      .text-con{
        flex: 1;height: 100%;display: inline-flex;justify-content: flex-end;align-items: center;
        .red{color: rgb(243,21,21);}
      }
      .icon-con{
        width: 24px;height: 100%;margin-right: 12px;
        display: inline-flex;justify-content: center;align-items: center;
      }
    }

    .deduct-from{
      display: flex;height: 44px;
      .left{
        width: 57px;height: 100%;font-size: 14px;font-weight: bold;
        display: inline-flex;padding-left: 12px;align-items: center;
      }
      .center{
        flex: 1;height: 100%;display: inline-flex;align-items: center;
        .icon{
          height: 13px;line-height: 1;font-size: 9px;
          padding-top: 1px;padding-right: 2px;color: #ff8f2c;
          display: inline-flex;align-items: center;justify-content: flex-end;
        }
        .icon1{
          width: 36px;
          background: url("@{url}FnFxsvRodfrGoVx_1jZxBCngcpou") no-repeat 50% 50%;
          background-size: 100%;
        }
        .icon2{
          width: 41px;
          background: url("@{url}FkMAXPaeTv8q8huTMXwOzrRCJIfG") no-repeat 50% 50%;
          background-size: 100%;
        }
        .icon3{
          width: 46px;
          background: url("@{url}Frv6kqJMlpqlYXPNWDE09fsUW84K") no-repeat 50% 50%;
          background-size: 100%;
        }
        .icon4{
          width: 51px;
          background: url("@{url}FghdLLwybeDJ8A-OW5WgGyA4O6p5") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }

    .detail-info{
      .detail-info-title{
        line-height: 44px;
        font-size: 16px;
        text-align: center;
        color: #070707;
        border-bottom: .5px solid #eee;
      }
      .detail-info-html{
        /*width: 100%;overflow-x: auto;*/
      }
      .detail-info-param{

      }
    }
    .select-cell{
      .cell-item{
        display: flex;
        align-items: center;

        .title{
          display: inline-flex;justify-content: center;align-items: center;
          font-size: 14px;font-weight: bold;line-height: 1;padding: 0 12px;
        }
        .right{
          flex: 1;
          border-bottom: 1px solid #eee;
          display: flex;justify-content: center;align-items: center;
          .text-con{
            flex: 1;display: inline-flex;justify-content: flex-start;align-items: center;
            font-size: 13px;color: #333;height: 100%;padding: 15px 0;
            .addr-text{
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
          }
          .icon{
            display: inline-flex;height: 100%;min-height: 44px;width: 32px;
            background: url("@{url2}icon-right.png") no-repeat 50% 50%;
            background-size: 8px 16px;
          }
        }

      }
    }

    .evaluation-con{
      .evaluation-header{
        display: flex;align-items: center;border-bottom: 1px solid #eee;height: 44px;
        .title{
          display: inline-flex;justify-content: center;align-items: center;
          font-size: 14px;font-weight: bold;line-height: 1;padding: 0 12px;
        }
        .right{
          flex: 1;
          display: flex;justify-content: center;align-items: center;
          .text-con{
            flex: 1;display: inline-flex;justify-content: flex-end;align-items: center;
            font-size: 13px;color: #666;height: 100%;
            .addr-text{
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
          }
          .icon{
            display: inline-flex;height: 100%;min-height: 44px;width: 32px;
            background: url("@{url2}icon-right.png") no-repeat 50% 50%;
            background-size: 8px 16px;
          }
        }
      }
      .evaluation-list{}
    }
  }
  .show-agent-sell{
    background: transparent;
    .show-agent-sell-con{
      width: 312.5px;height: 377px;color: #fff;font-size: 16px;
      background: transparent url("@{url2}show-agent-sell-bg.png") no-repeat 50% 0;
      background-size: 100%;
      .title{font-size: 30px;text-align: center;line-height: 1;padding-top: 46px;}
      .item{
        width: 226px;height: 50px;margin: 0 auto;
        display: flex;
        .left{width: 48px;height: 100%;}
        .text{
          width: 70px;
          display: inline-flex;justify-content: flex-start;align-items: center;
        }
        .right{
          flex: 1;padding-right: 15px;
          display: inline-flex;justify-content: flex-end;align-items: center;
        }

        &.item1{
          margin-top: 39px;
          .left{
            background: url("@{url2}medal-bronze.png") no-repeat 15px 5px;
            background-size: 23px 34px;
          }
        }
        &.item2{
          margin-top: 10px;
          .left{
            background: url("@{url2}medal-silver.png") no-repeat 15px 5px;
            background-size: 23px 34px;
          }
        }
        &.item3{
          margin-top: 10px;
          .left{
            background: url("@{url2}medal-gold.png") no-repeat 15px 5px;
            background-size: 23px 34px;
          }
        }
        &.active{
          background-image: linear-gradient(rgb(255,255,255), rgb(247,216,214));
          border-radius: 25px;color: #f1323e;
        }
      }
      .close-icon{
        width: 30px;height: 30px;position: absolute;bottom: 0;left: 140px;
        background: url("@{url2}close-icon.png") no-repeat 50% 50%;background-size: 100%;
      }


    }
  }
  .technical-support{
    background-color: #f4f4f4;
    text-align: center;
    font-size: 12px;
    color: #999;
    padding: 24px 0;
  }
  .feedback-con{
    .title{
      line-height: 1;padding: 15px;
      font-size: 18px;color: #333;
      text-align: center;
    }
    .feedback-textarea{
      font-size: 12px;color: #999;
    }
  }
  .is-area-restrict{
    height: 20px;position: fixed;left: 0;right: 0;bottom: 50px;
    display: flex;justify-content: center;align-items: center;
    font-size: 10px;color: #f74646;background-color: #ffdfdf;
  }
  .detail-bottom-con{
    position: fixed;
    z-index: 1099;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    display: flex;
    border-top: 1px solid #f5f5f5;
    background-color: #fff;
    .item-con{
      flex: 1;
      display: inline-flex;
      font-size: 10px;
      color: #333;
      .item{
        display: inline-flex;
        width: 30px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex: 1;
        .icon{
          display: block;
        }
        .icon1{
          width: 17px;
          height: 17px;
        }
        .icon2{
          width: 21px;
          height: 18px;
        }
        .icon3{
          width: 20px;
          height: 20px;
        }
        .icon4{
          width: 20px;
          height: 20px;
        }
        .text{
          padding-top: 2px;
        }
      }
    }
    .buy-btn-con{
      display: inline-flex;width: 233px;
      .btn-con{
        flex: 1;display: inline-flex;justify-content: space-evenly;align-items: center;
        .btn{
          display: inline-flex;justify-content: center;align-items: center;
          font-size: 14px;border-radius: 18px;color: #fff;width: 102px;height: 35px;
          &.add-to-cart{background-color: #1585f3;}
          &.buy-at-once{background-color: #f74646;}
        }
        &.no-goods{
          .add-to-cart{background-color: rgba(21, 133, 243, 0.5);}
          .buy-at-once{background-color: rgba(247, 70, 70, 0.5);}
        }
      }
    }
  }
}
</style>
<style lang="less">
.jd-goods-detail{
  .detail-con{
    .detail-info{
      .detail-info-html{
        .detail-info-html-con{
          font-size: 14px;
          img{
            display: block;margin: 0;padding: 0;
            width: 100%;
          }
          table{
            width: 100%!important;
            td{width: auto!important;height: auto!important;}
            img{
              /*width: min-content!important;height: min-content!important;*/
            }
          }

        }
      }


      .detail-info-param{
        table{
          table-layout: fixed;border-collapse: separate;box-sizing: inherit;
          font-size: 14px;color: #A1A2A5;border-top: 1px solid #EBEEF5;
          tr{
            th{
              text-align: left;
              padding: 15px;
              color: #686868;
              border-bottom: 1px solid #EBEEF5;
            }
            td{
              border-right: 1px solid #EBEEF5;border-bottom: 1px solid #EBEEF5;
              box-sizing: border-box;
              text-overflow: ellipsis;
              vertical-align: middle;
              position: relative;
              text-align: left;
              min-width: 0;
              padding: 12px;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
</style>